import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";
import { findUsuarioCartaoCreditoByCurrentUser } from "./api-usuario-cartao-credito";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import UsuarioCartaoCreditoList from "./UsuarioCartaoCreditoList";
import Loading from "../UI/Loading";
import SettingsCard from "../Configuracao/SettingsCard";

const UsuarioCartaoCreditoContainer = () => {
  const [listUsuarioCartaoCredito, setListUsuarioCartaoCredito] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    findUsuarioCartaoCreditoByCurrentUser()
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
        } else if (Array.isArray(data)) {
          setListUsuarioCartaoCredito(data);
        }
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <SettingsCard
      title="Meus Cartões"
      description="Cartões de crédito salvos para pagamentos."
      contentPadding={false}
      action={
        <Button size="small" startIcon={<AddIcon />} component={Link} to="/insere-novo-cartao-credito">
          Novo Cartão
        </Button>
      }
    >
      {isLoading ? (
        <Box py={3}>
          <Loading size={28} description="Carregando cartões..." />
        </Box>
      ) : (
        <UsuarioCartaoCreditoList listUsuarioCartaoCredito={listUsuarioCartaoCredito} />
      )}
    </SettingsCard>
  );
};

export default UsuarioCartaoCreditoContainer;
